import {TestType} from '../types';

export const testLabelByTestType: Record<TestType, string> = {
	[TestType.YN]: 'Yes/No',
	[TestType.Score]: 'Single Score',
	[TestType.Rubric]: 'Rubric',
	[TestType.General]: 'General',
	[TestType.None]: '',
};
